export enum EmailContentType {
    TEXT    = 1,
    HTML    = 2
}
